module.exports = __webpack_public_path__ + "src/assets/img/selector-plotkin-plane.ad581394.png";